/**
 * Created by hernanherreros on 2019-05-28
 */

import * as React from 'react'
import styled, { css } from 'styled-components'
import { Trans } from '@lingui/macro'
import Countdown from './Countdown'
import { fontSize, FontSizeProps, color, ColorProps, WidthProps } from 'styled-system'

interface TimerProps {
  color: string;
  minutes?: number;
  changeExpiredState?: any;
}

export default class Timer extends React.Component<TimerProps> {
  render () {
    const { color, minutes, changeExpiredState } = this.props

    return (
      <Container color={color}>
        <CountDownWrapper width={minutes !== undefined ? '250px' : '230px'}>
          <Countdown color={color} minutes={minutes} changeExpiredState={changeExpiredState}/>
        </CountDownWrapper>

        <Content>
          { minutes !== undefined ?

            <React.Fragment>
              <Text fontSize={[0, 1]} color="black"><Trans>Tiene 72 horas para invitar a los miembros de su delegación. Una vez cumplido el tiempo, el formulario será inhabilitado.</Trans></Text>
            </React.Fragment>
            :
            <React.Fragment>
              <Limited fontSize={[1, 2, 3]} color={color}>
                <Trans>Cupos limitados</Trans>
              </Limited>
              <Heading fontSize={[1, 2, 3]}>
                <Trans>Registro</Trans>
               </Heading>
              <Text fontSize={[0, 1]} color="black"><Trans>Para finalizar, complete su registro en los próximos 15
              minutos, de lo contrario se liberará el cupo.</Trans></Text>
            </React.Fragment>
          }
        </Content>
      </Container>
    )
  }
}

const Container = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  
  @media screen and (max-width: 40em) {
    flex-direction: column;
  }
  
  ${({ color }) => css`border: 1px ${color} solid;`}
`

const CountDownWrapper = styled.div<WidthProps>`
  ${({ width }) => css `width: ${width};`} 
  margin-right: 20px;
  padding: 10px 0;
  
  @media screen and (max-width: 40em) {
    margin: 0;
  }
`

const Content = styled.div`
  flex: 1;
  
  * {
    margin: 0;
  }
`

const Heading = styled.h1<FontSizeProps>`
  @media screen and (max-width: 40em) {
    margin-bottom: 16px;
  }

  ${fontSize}
`

const Text = styled.p<FontSizeProps & ColorProps>`
  @media screen and (max-width: 40em) {
  }

  ${fontSize}
  ${color}
`

const Limited = styled.div<FontSizeProps & ColorProps>`
  font-size: 12px;
  float: right;
  color: #ffffff;
  border-radius: 5px;
  padding: 1px 16px;
  font-weight: bold;
  margin-top: 4px;

  ${({ color }) => css`background-color: ${color};`}
`
